import {
  AppNotification,
  NotificationType,
} from '../../../components/notification/Notification'
import { useDeleteDebounce } from '../../../utils/useDeleteDebounce'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useArchiveMultipleGuestTypeMutation } from '../../../core/api/GuestTypeApi'
import { IChooseItems } from 'core/api/dto/BuffetDishDto'

interface UseDeleteGuestTypeResponse {
  deletePopup: boolean
  onDeletePopupHandler: () => void
  onDeleteHandler: () => void
  closeDeletePopup: () => void
}

export const useDeleteGuestType = (
  chooseItems: IChooseItems | null,
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>,
): UseDeleteGuestTypeResponse => {
  const [deletePopup, setDeletePopup] = useState(false)
  const [archiveMultipleGuestType] = useArchiveMultipleGuestTypeMutation()
  const { t } = useTranslation()

  const deleteGuestTypeHandler = async () => {
    if (!!chooseItems) {
      archiveMultipleGuestType({
        plan_menu_guest_type_list: Object.keys(
          Object.fromEntries(
            Object.entries(chooseItems).filter((e) => e.includes(true)),
          ),
        ).map((item) => Number(item)),
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Выбранные типы гостей успешно удалены!'),
            type: NotificationType.success,
          })
          setChooseItems(null)
        })
    }
  }

  const [onDeleteHandler] = useDeleteDebounce({
    fn: deleteGuestTypeHandler,
    extraText: t('Выбранные вами типы гостей будут удалены!'),
  })

  const closeDeletePopup = () => setDeletePopup(false)
  const openDeletePopup = () => setDeletePopup(true)

  return {
    deletePopup,
    onDeletePopupHandler: openDeletePopup,
    onDeleteHandler,
    closeDeletePopup,
  }
}
